<app-content-header
    i18n-title
    title="Finished destinations"
    i18n-subTitle
    subTitle="Destinations finished preparation and ready for import"
    [backgroundImage]="backgroundImage"
    [containerClass]="containerClass"
    [subContainerClass]="subContainerClass"
    [pyClass]="pyClass"
    [contentClass]="contentClass"
    [h1class]="h1class"
    [h2class]="h2class"
    [subContainerBackgroundImage]="subContainerBackgroundImage"
    [containerBackgroundImage]="containerBackgroundImage"
></app-content-header>

<app-content-breadcrumb
    [elements]="breadCrumbElements"
></app-content-breadcrumb>
<div class="content">
    <div class="row">
        <div class="col-md-3">
            <div class="block">
                <div class="block-header block-header-default">
                    <h3 class="block-title">Filter</h3>
                </div>
                <div class="block-content block-content-full">
                    <app-destination-filter
                        [filter]="searchParams"
                        (onSearch)="reloadDestinations(true)"
                    ></app-destination-filter>
                </div>
            </div>
        </div>
        <div class="col-md-9">
            <div class="block block-bordered">
                <div class="block-header block-header-default">
                    <h3 class="block-title">Destinations</h3>
                </div>
                <div class="block-content">
                    <app-destination-table
                        (actionClicked)="actionClicked($event)"
                        (paginate)="sendPage($event)"
                        [importProgress]="importProgress"
                        [additionalFields]="additionalFields"
                        [destinations]="destinations"
                        [pagination]="pagination"
                    ></app-destination-table>
                </div>
            </div>
        </div>
    </div>
</div>
